export const locale = {
  lang: 'es',
  data: {
    'CONTRO_ENCU': {
      'TIT_ENCABE':'Control de encuestas',
      'CHAN_INFO':'Cargando información',
      'TEX_INTRUCC':'* Realice la busqueda seleccionando el/los filtros',
      'SELEC_INSTI':'Instituto',
      'SELEC_YEA':'Año',
      'SELEC_TI_ENC':'Productos',
      'SELEC_ESTA':'Estatus',
      'BTN_FIL_INFO':'Filtrar encuestas',
      'COMFI_UPDA_TEX':'Estás seguro de actualizar?',
      'BTN_ACEP':'Aceptar',
      'BTN_CANC':'Cancelar',
      'TEX_MOD_UPTD':'Actualizando',
      'TEX_SUCC_MOD_UPTD':'Se actualizo correctamente',
      'USE':'Usuario:',
      'DAT':'Fecha:',
      'ACC':'Acción:',
      'ACC_EVENT':{
      '0':'Desactivado',
      '1':'Activado',
    },
      'NAM_TH':{
         'TH_NAM':'Empresa',
         'TH_TI_ENCU':'Tipo encuesta',
         'TH_DAT_APLI':'Fecha aplicación',
         'TH_ESTA':'Estatus',
         'TH_TOKE':'Token',
         'TH_HC':'HC',
         'TH_RESPU':'Respuestas',
         'TH_DAT_CLO':'Fecha cierre',
         'TH_PRORR':'Prorroga',
         'TH_REPO_EXC':'Reporte excel',
         'TH_ONLI':'Online',
         'TH_OFFLI':'Offline',
         'TH_AUDIT':'Auditoria	',
         'TH_SECT':'Sector',
         'TH_SUBSECT':'Sub sector',
         'TH_LIPROY':'Lider proyecto',
         'TH_JEFPROY':'Jefe proyecto',
      }
    },

  }
};
